module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "th"
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-60e0c1d0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/Table/ThCell.vue
// module id = 1389
// module chunks = 0